module.exports = __webpack_public_path__ + "static/media/ezequiel_fernandez.715fefb7.jpg";